var EventTypesEnum;
(function (EventTypesEnum) {
    EventTypesEnum["Default"] = "DEFAULT";
    EventTypesEnum["AllDay"] = "ALL_DAY";
    EventTypesEnum["MultiDay"] = "MULTIDAY";
    EventTypesEnum["AllDayMultiDay"] = "ALL_DAY_MULTIDAY";
    EventTypesEnum["Filler"] = "FILLER";
    EventTypesEnum["Null"] = "NULL";
    EventTypesEnum["ShowMore"] = "SHOW_MORE";
})(EventTypesEnum || (EventTypesEnum = {}));
export default EventTypesEnum;
//# sourceMappingURL=EventTypesEnum.js.map